module.exports = __webpack_public_path__ + "img/kyc-details.aeaa19cd.svg";